import { COLOUR } from '../../../utils/constants';

const BORDER_COLOUR = '#555';

export default {
  root: {
    display: 'flex'
  },
  filterButton: {
    borderLeft: 'none',
    padding: '1em'
  },
  expandButton: {
    position: 'absolute',
    left: '26px',
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    height: '50px'
  },
  timeline: height => ({
    flexGrow: 1,
    height: `${height}px`,
    display: 'inline-flex',
    alignItems: 'center',
    border: `1px solid ${BORDER_COLOUR}`,
    background: COLOUR.MEDIUM_GREY,
    position: 'relative',
    cursor: 'default'
  }),
  trendLabel: { 
    position: 'absolute',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'clip',
    margin: 0,
    cursor: 'pointer'
  },
  trendLabelButton: {
    border: 'none'
  },
  trendLabelDividingHeader: {
    fontSize: '1em'
  },
  trendDescription: {
    whiteSpace: 'pre-wrap',
    maxHeight: '10em',
    overflowY: 'scroll'
  },
  trendLabelPopup: {
    background: COLOUR.DARK_GREY,
    border: '1px solid white',
    minWidth: '350px'
  },
  trendLabelUnitSubheader: {
    color: COLOUR.TEXT,
    fontWeight: 'bold'
  },
  trendLabelPopupContent: {
    maxHeight: '30em',
    overflowY: 'scroll'
  }
};